/**
 * <s-countdown data-end="ISO-8601"> — ticks down to `data-end` every second,
 * writing zero-padded values into its [data-unit="days|hours|minutes|seconds"]
 * children. When the end passes it sets `data-ended` on itself so CSS can swap
 * in the ended message. Without JS the server-rendered values stay visible.
 */
class SCountdown extends HTMLElement {
  /** @type {number | undefined} */
  #timer;

  connectedCallback() {
    const end = Date.parse(this.dataset.end ?? '');
    if (Number.isNaN(end)) return;

    const units = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };

    const tick = () => {
      const left = Math.max(0, end - Date.now());
      const total = Math.floor(left / 1000);
      const values = {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60,
      };
      for (const [key, el] of Object.entries(units)) {
        if (el) el.textContent = String(values[key]).padStart(2, '0');
      }
      if (left === 0) {
        this.toggleAttribute('data-ended', true);
        window.clearInterval(this.#timer);
      }
    };

    tick();
    this.#timer = window.setInterval(tick, 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
